import { Injectable } from '@angular/core';
import {
  API_ENDPOINTS,
  formatDateToSqlTimestamp,
  setEndOfDayTime,
} from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { IContactDetailedInsight } from './contact-detailed-insights.interface';
import {
  IContactInsightRequest,
  IContactInsightResponse,
} from './contact-insight-report.interface';
import { HttpService } from '../../core/http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class ContactInsightService {
  constructor(private _httpService: HttpService) {}

  /**
   * Fetches contact insights reports based on filters like timePeriod, reportType, and optional custom dates.
   * @param params Object containing  reportType, and optional startDate/endDate if timePeriod is CUSTOM.
   */
  /**
   * @param autoFallback when true the server ignores the dates in `params` and picks the narrowest
   * window that actually holds leads, echoing the choice back on `appliedPeriod`. Sent on first
   * load only — once the user picks a range themselves, their choice is respected.
   */
  public getContactInsights(
    params: IContactInsightRequest,
    autoFallback = false
  ): Observable<IContactInsightResponse> {
    const formattedStartDate = params.startDate
      ? formatDateToSqlTimestamp(new Date(params.startDate))
      : '';
    const convertedEndDate = setEndOfDayTime(new Date(params.endDate));
    const formattedEndDate = params.endDate
      ? formatDateToSqlTimestamp(new Date(convertedEndDate))
      : '';

    return this._httpService.get<IContactInsightResponse>(
      API_ENDPOINTS.REPORTS_ENDPOINTS.PLATFORM_REPORTS.getContactInsights(
        params.reportType,
        formattedStartDate || '',
        formattedEndDate || '',
        params.unit,
        autoFallback
      )
    );
  }

  public getContactDetailedInsightBySource(
    source: string,
    params: IContactInsightRequest
  ): Observable<IContactDetailedInsight> {
    const formattedStartDate = params.startDate
      ? formatDateToSqlTimestamp(new Date(params.startDate))
      : '';

    const convertedEndDate = setEndOfDayTime(new Date(params.endDate));
    const formattedEndDate = params.endDate
      ? formatDateToSqlTimestamp(new Date(convertedEndDate))
      : '';
    return this._httpService.get<IContactDetailedInsight>(
      API_ENDPOINTS.REPORTS_ENDPOINTS.PLATFORM_REPORTS.getContactDetailedInsights(
        params.reportType,
        formattedStartDate || '',
        formattedEndDate || '',
        source
      )
    );
  }
}
